import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    programQuery,
    programQueryVariables,
} from "./__graphql-types__/programQuery.ts";

export const PROGRAM_QUERY: GqlOperation<programQuery, programQueryVariables> =
    gqlOp(gql`
        query programQuery($programId: String!) {
            programById(id: $programId) {
                byChild
                category
                created
                creatorProfile: author {
                    id
                    nickname
                    profileRoot
                    profile {
                        accessLevel
                    }
                }
                deleted
                description
                spinoffCount: displayableSpinoffCount
                docsUrlPath
                flags
                flaggedBy: flaggedByKaids
                flaggedByUser: isFlaggedByCurrentUser
                height
                hideFromHotlist
                id
                imagePath
                isProjectOrFork: originIsProject
                isOwner
                kaid: authorKaid
                key
                newUrlPath
                originScratchpad: originProgram {
                    deleted
                    translatedTitle
                    url
                }
                restrictPosting
                revision: latestRevision {
                    id
                    code
                    configVersion
                    created
                    editorType
                    folds
                }
                slug
                sumVotesIncremented
                title
                topic: parentCurationNode {
                    id
                    nodeSlug: slug
                    relativeUrl
                    slug
                    translatedTitle
                }
                translatedTitle
                url
                userAuthoredContentType
                upVoted
                width
            }
        }
    `);
